import Static from './Static';

export default Static;
